import { render, staticRenderFns } from "./IndividualJDModal.vue?vue&type=template&id=6f2a57e4&scoped=true&"
import script from "./IndividualJDModal.vue?vue&type=script&lang=js&"
export * from "./IndividualJDModal.vue?vue&type=script&lang=js&"
import style0 from "./IndividualJDModal.vue?vue&type=style&index=0&id=6f2a57e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2a57e4",
  null
  
)

export default component.exports